
import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom'; // Added useLocation
import { useToast } from '@/hooks/toast/index';

const RecoveryCodeHandler = () => {
  const navigate = useNavigate();
  const location = useLocation(); // Use useLocation to get current location object
  const { toast } = useToast();
  const hasRedirectedRef = useRef(false);

  useEffect(() => {
    if (hasRedirectedRef.current) {
      console.log('RecoveryCodeHandler: Already redirected, skipping further checks.');
      return;
    }

    const hash = location.hash; // Use location.hash
    const search = location.search; // Use location.search

    console.log('RecoveryCodeHandler: Checking URL params. Hash:', hash, 'Search:', search);

    // Priority 1: Handle Password Recovery from Hash (PKCE or other token types)
    if (hash && hash.includes('type=recovery')) {
      const hashParams = new URLSearchParams(hash.substring(1)); // Remove #
      if (hashParams.get('code') || hashParams.get('access_token')) { // Check for PKCE code or older access_token
        console.log('RecoveryCodeHandler: Password recovery params (PKCE code or access_token) detected in HASH:', hash);
        hasRedirectedRef.current = true;
        navigate('/reset-password' + hash, { replace: true });
        return;
      }
    }

    // Priority 2: Handle Password Recovery from Search (PKCE)
    if (search && search.includes('type=recovery')) {
      const searchParams = new URLSearchParams(search);
      if (searchParams.get('code')) { // Specifically check for PKCE code
        console.log('RecoveryCodeHandler: Password recovery params (PKCE code) detected in SEARCH:', search);
        hasRedirectedRef.current = true;
        navigate('/reset-password' + search, { replace: true });
        return;
      }
    }

    // Priority 3: Handle Email Confirmation (signup or email change) from Hash
    if (hash && (hash.includes('type=signup') || hash.includes('type=email_change'))) {
      const hashParams = new URLSearchParams(hash.substring(1)); 
      const type = hashParams.get('type');
      console.log(`RecoveryCodeHandler: Email confirmation type ('${type}') detected in HASH:`, hash);
      hasRedirectedRef.current = true;
      navigate('/auth/account-activated' + hash, { replace: true });
      return;
    }

    // Priority 4: Handle other auth flows (e.g., magic link, OAuth) that result in a session directly from Hash
    if (hash && hash.includes('access_token')) {
      const hashParams = new URLSearchParams(hash.substring(1));
      const type = hashParams.get('type');
      // Ensure this isn't a recovery/signup/email_change flow that should have been caught earlier
      if (type !== 'recovery' && type !== 'signup' && type !== 'email_change') {
        console.log('RecoveryCodeHandler: General auth token (e.g., magic link, OAuth) detected in HASH:', hash, 'Params:', hashParams.toString());
        hasRedirectedRef.current = true;
        toast({
          title: "Autentifikim i suksesshëm",
          description: "Ju jeni identifikuar me sukses. Mirë se vini!",
        });
        navigate('/', { replace: true });
        return;
      } else {
        console.log(`RecoveryCodeHandler: HASH with access_token also has type '${type}', which should have been handled by prior checks. This indicates a potential logic overlap or specific scenario not fully covered.`)
      }
    }

    console.log('RecoveryCodeHandler: No specific auth redirection needed based on current hash/search params.');

  }, [navigate, location, toast]); // Added location to dependencies

  return null;
};

export default RecoveryCodeHandler;
